<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
          v-bind="attrs"
          v-on="on"
          small
          class="ml-1 license-missing-icon"
          color="grey"
      >
        mdi-lock
      </v-icon>
    </template>
    <span v-if="normalizedLicenseKeys.length === 1">{{ $t('license.module_not_licensed', {module: getModuleName(normalizedLicenseKeys[0])}) }}</span>
    <span v-else>{{ $t('license.modules_not_licensed', {modules: moduleNames}) }}</span>
  </v-tooltip>
</template>

<script>
import {sessionStore} from "@/store/pinia/sessionStore";

export default {
  name: 'LicenseMissingIcon',
  props: {
    licenseKey: {
      type: String,
      required: false
    },
    licenseKeys: {
      type: Array,
      required: false
    }
  },
  setup() {
    const session = sessionStore();
    return { session };
  },
  computed: {
    normalizedLicenseKeys() {
      if (this.licenseKeys && this.licenseKeys.length > 0) {
        return this.licenseKeys;
      }
      if (this.licenseKey) {
        return [this.licenseKey];
      }
      return [];
    },

    moduleNames() {
      return this.normalizedLicenseKeys
        .map(key => this.getModuleName(key))
        .join(', ');
    }
  },
  methods: {
    getModuleName(licenseKey) {
      const moduleInfo = this.session.getModuleInfo(licenseKey);
      return moduleInfo?.name || licenseKey;
    }
  }
}
</script>

<style>
.license-missing-icon {
  pointer-events: auto !important;
  position: relative;
}
</style>
